import { REPOSITORY } from '../../api/repository/Repository'

const loginCompany = async (sGuidLogin) => {
  const response = await REPOSITORY.wsEmpresa.login(sGuidLogin)
  return response.data
}
export async function loginUser(dispatch, loginPayload) {
  try {
    dispatch({ type: 'REQUEST_LOGIN' })
    const data = await loginCompany(loginPayload)

    if (data.sUsuario) {
      dispatch({
        type: 'LOGIN_SUCCESS',
        payload: { user: data, auth_token: loginPayload },
      })
      REPOSITORY.local.company.setUserData(data)
      return data
    }

    dispatch({ type: 'LOGIN_ERROR', error: data.errors[0] })
    return data.errors[0]
  } catch (error) {
    dispatch({ type: 'LOGIN_ERROR', error })
  }
  return null
}

export async function logout(dispatch) {
  dispatch({ type: 'LOGOUT' })
  localStorage.removeItem('currentUser')
  localStorage.removeItem('token')
}
